import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useReadOnlyStatus, V3_APP_URL } from "../../helpers/legacyReadOnly";

// Shown at the top of the file manager once this legacy workspace has been frozen read-only after
// migration. Nudges users to the new v3 platform. Renders nothing unless read-only.
export default function ReadOnlyBanner() {
  const { readOnly } = useReadOnlyStatus();
  if (!readOnly) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        px: 2.5,
        py: 1.75,
        mb: 2,
        borderRadius: 2,
        bgcolor: "#EEF4FF",
        border: "1px solid #DbE4FF",
        borderLeft: "4px solid #2563EB",
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          flex: "none",
          borderRadius: 1.5,
          display: "grid",
          placeItems: "center",
          bgcolor: "#2563EB",
          color: "#fff",
        }}
      >
        <SyncAltIcon fontSize="small" />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontWeight: 700, color: "#0F172A" }}>
          Your account has moved to the new DocPlace
        </Typography>
        <Typography variant="body2" sx={{ color: "#475569" }}>
          This workspace is now <b>read-only</b> — uploads and edits are turned off here. Continue in
          the new version.
        </Typography>
      </Box>
      <Button
        href={V3_APP_URL}
        endIcon={<ArrowForwardIcon />}
        variant="contained"
        sx={{
          flex: "none",
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 1.5,
          bgcolor: "#2563EB",
          "&:hover": { bgcolor: "#1D4ED8" },
        }}
      >
        Take me there
      </Button>
    </Box>
  );
}
